import hostUserProfileEventListenersFactory from "./hostUserProfileEventListeners";
import { foundation, appChannels } from "@teaming/slice-engine";
import { summarizeWorkStyle } from "@teaming/common-ui";

export default function hostLayoutStoreFactory() {
	const { store, auth, } = foundation();
	const { ioChannel, } = appChannels;

	hostUserProfileEventListenersFactory( { auth, ioChannel, store, } );

	const WORKSTYLE_SUMMARY_ATTRIBUTE_QUANTITY = 5;

	return store.registerModule( "host-userProfile", {
		namespaced: true,
		state: {
			user: {},
			auth0User: {},
			isLoggedIn: false,
		},
		getters: {
			userProfile: state => state.user,
			timezone: state => state.user?.timezone || "",
			isVerified: state => state.auth0User && state.auth0User.email_verified,
			isLoggedIn: state => state.isLoggedIn,
		},
		actions: {},
		mutations: {
			receiveUserProfile( state, userProfile ) {
				const assessment = userProfile?.assessments?.DISC;
				let workStyleSummary = null;
				if ( assessment ) {
					workStyleSummary = summarizeWorkStyle(
						assessment,
						WORKSTYLE_SUMMARY_ATTRIBUTE_QUANTITY
					);
				}
				state.user = {
					...userProfile,
					workStyleSummary,
				};
			},
			receiveAuth0Profile( state, auth0User ) {
				state.auth0User = auth0User;
			},
			receiveLoginStatus( state, { isLoggedIn, } ) {
				state.isLoggedIn = isLoggedIn;
			},
		},
	} );
}
